// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms-of-sales-container[data-v-39dcf036] {\n  position: relative;\n  min-height: 100vh;\n  background-color: black;\n  padding-top: 8rem;\n}", ""]);
// Exports
module.exports = exports;
